// extracted by mini-css-extract-plugin
export var completionBody = "_mt-2";
export var completionCard = "_mt-0";
export var completionFooter = "_mt-3";
export var completionTitle = "_mt-1";